/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Backdrop, CircularProgress } from '@mui/material';
/**
 * Loader common component that uses across modules for indicate loading state
 * @param children - child component which needs to wrap from the loader
 * @param loading - loading state
 */
const Loader = ({ children, loading }) => (
  <>
    <Backdrop
      sx={(theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: '#00000066',
        display: 'flex',
      })}
      open={loading}
    >
      <CircularProgress thickness={4} />
    </Backdrop>
    {children}
  </>
);
//
export default Loader;
